/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';

export default (): JSX.Element => (
  <svg width={177} height={141} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient
        x1="-15.656%"
        y1="90.394%"
        x2="115.609%"
        y2="9.636%"
        id="prefix__a"
      >
        <stop stopColor="#C1C7D0" offset="3%" />

        <stop stopColor="#EBECF0" offset="73%" />
      </linearGradient>

      <linearGradient
        x1="2.809%"
        y1="103.165%"
        x2="97.191%"
        y2="-3.165%"
        id="prefix__b"
      >
        <stop stopColor="#253858" offset="15%" />

        <stop stopColor="#273A59" offset="64%" />

        <stop stopColor="#2E405F" offset="82%" />

        <stop stopColor="#394A67" offset="94%" />

        <stop stopColor="#42526E" offset="100%" />
      </linearGradient>

      <linearGradient
        x1="0%"
        y1="49.992%"
        x2="100%"
        y2="49.992%"
        id="prefix__c"
      >
        <stop stopColor="#6C798F" offset="0%" />

        <stop stopColor="#EBECF0" offset="100%" />
      </linearGradient>

      <linearGradient
        x1="-7.957%"
        y1="49.728%"
        x2="103.835%"
        y2="49.728%"
        id="prefix__d"
      >
        <stop stopColor="#A5ADBA" offset="2%" />

        <stop stopColor="#EBECF0" offset="100%" />
      </linearGradient>

      <linearGradient
        x1="-307%"
        y1="14862%"
        x2="24618%"
        y2="14862%"
        id="prefix__e"
      >
        <stop stopColor="#A5ADBA" offset="2%" />

        <stop stopColor="#EBECF0" offset="100%" />
      </linearGradient>
    </defs>

    <g fill="none" fillRule="evenodd">
      <path
        d="M140.92 27.052a108.212 108.212 0 0034.678 52.213"
        stroke="#DFE1E5"
        strokeWidth={2}
      />

      <path
        d="M31.462 27.075a168.062 168.062 0 01-12.811 46.349A167.653 167.653 0 01.835 104.447"
        stroke="#C1C7D0"
        strokeWidth={2}
      />

      <path
        fill="url(#prefix__a)"
        fillRule="nonzero"
        d="M56.389.037h16.228v26.44H56.389z"
      />

      <path
        fill="#EBECF0"
        fillRule="nonzero"
        d="M99.913.037h16.228v26.44H99.913z"
      />

      <path
        fill="url(#prefix__b)"
        fillRule="nonzero"
        d="M30.688 26.477h111.115v98.911H30.688z"
      />

      <path
        d="M55.064 39.045H84.56m-42.06 0h7.49"
        stroke="#3384FF"
        strokeWidth={2}
      />

      <path d="M55.064 47.41H84.56" stroke="#FF7452" strokeWidth={2} />

      <path
        d="M42.5 47.41h7.49m5.074 8.366h55.414m-67.978 0h7.49"
        stroke="#3384FF"
        strokeWidth={2}
      />

      <path d="M110.478 64.142h19.287" stroke="#FF7452" strokeWidth={2} />

      <path d="M79.2 64.142h25.36" stroke="#FAFBFC" strokeWidth={2} />

      <path d="M55.064 64.142h17.204" stroke="#FF7452" strokeWidth={2} />

      <path
        d="M42.5 64.142h7.49m5.074 8.365h55.414m-67.978 0h7.49m5.074 8.366H84.56m-42.06 0h7.49"
        stroke="#3384FF"
        strokeWidth={2}
      />

      <path d="M55.064 89.238H84.56" stroke="#FF7452" strokeWidth={2} />

      <path d="M42.5 89.238h7.49" stroke="#3384FF" strokeWidth={2} />

      <path
        d="M55.064 97.604h54.152"
        stroke="#2684FF"
        strokeWidth={2}
        fill="#FFAB00"
        fillRule="nonzero"
      />

      <path
        d="M42.5 97.604h7.49m-7.49-8.366h7.49m-7.49 8.366h7.49"
        stroke="#3384FF"
        strokeWidth={2}
      />

      <path d="M55.064 105.97H84.56" stroke="#FFAB00" strokeWidth={2} />

      <path
        d="M42.5 105.97h7.49m41.34 8.365h17.886"
        stroke="#3384FF"
        strokeWidth={2}
      />

      <path d="M55.064 114.335H84.56" stroke="#FAFBFC" strokeWidth={2} />

      <path d="M42.5 114.335h7.49" stroke="#3384FF" strokeWidth={2} />

      <path
        d="M176.343.016l-17.971 61.641c-3.57-.717-143.814-.779-147.207 0L0 25.221l79.535-.777a33.21 33.21 0 0025.414-12.226A33.217 33.217 0 01130.681 0l45.662.016z"
        transform="translate(.619 78.628)"
        fill="url(#prefix__c)"
        fillRule="nonzero"
      />

      <path
        d="M105.087 90.893a33.21 33.21 0 01-25.414 12.226l-79.535.776 2.424 7.768h163.5l6.778-21.43h-67.102c-.24.186-.45.411-.651.66z"
        fill="url(#prefix__d)"
        fillRule="nonzero"
      />

      <path
        d="M116.582 81.882a33.043 33.043 0 00-4.082 2.33h62.23l1.751-5.522h-45.7c-4.91 0-9.76 1.09-14.199 3.192z"
        fill="url(#prefix__e)"
        fillRule="nonzero"
      />

      <path
        d="M105.738 90.178h67.141l1.89-5.98H112.5a33.399 33.399 0 00-6.761 5.98z"
        fill="#FF7452"
        fillRule="nonzero"
      />

      <ellipse
        fill="#A5ADBA"
        fillRule="nonzero"
        cx={124.948}
        cy={100.889}
        rx={4.787}
        ry={4.8}
      />

      <ellipse
        fill="#A5ADBA"
        fillRule="nonzero"
        cx={146.698}
        cy={100.889}
        rx={4.787}
        ry={4.8}
      />

      <path
        fill="#FF7452"
        fillRule="nonzero"
        d="M56.389 3.991h16.228v5.36H56.389zm43.524 0h16.228v5.36H99.913z"
      />
    </g>
  </svg>
);
